<base-index-page
    [config]="baseIndexPageConfig"
    [service]="qualityManagementService"
    [idKey]="'meetingMinuteId'"
    [subSectionSettings]="'deleteMeetingMinute'"
></base-index-page>
